import React, { Component } from 'react'
import { Field } from 'redux-form'
import RichText from './RichText'

class RichTextInput extends Component {
  render() {
    if (this.props.source) {
      return <Field component={RichText} {...this.props} name={this.props.name ? this.props.name : this.props.source} />
    } else {
      return <RichText {...this.props} />
    }
  }
}

export default RichTextInput
